export default {
  config: {},
  orgLogo: '',
  orgLogoMobile: '',
  backgroundImg: '',
  kmlFile: '',
  registrationFields: []
}
